import {lazy, Suspense, useEffect} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {AppShell} from '../layout/AppShell'
import {LoadingScreen} from '../components/LoadingScreen'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {InstrumentsWrapper} from '../pages/InstrumentsPage'
import {ConnectorsSettingsWrapper} from '../pages/ConnectorsSettingsPage'
import {StandingOrdersWrapper} from '../pages/StandingOrdersPage'
import PortfolioAccountsPage from '../pages/PortfolioAccountsPage'
import {ensureBlazorStarted} from '../modules/blazor/startBlazor'

const PrivateRoutes = () => {
  // Запускаем Blazor Server только в авторизованной части приложения, чтобы custom elements
  // успели зарегистрироваться. Вызов идемпотентен и безопасен при повторном рендеринге.
  useEffect(() => {
    ensureBlazorStarted()
  }, [])

  const StrategiesPage = lazy(() => import('../pages/StrategiesPage'))

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='instruments' element={<InstrumentsWrapper />} />
        <Route path='settings/connectors' element={<ConnectorsSettingsWrapper />} />
        <Route path='trading/standing-orders' element={<StandingOrdersWrapper />} />
        <Route
          path='strategies/*'
          element={
            <Suspense fallback={<LoadingScreen compact />}>
              <StrategiesPage />
            </Suspense>
          }
        />
        <Route
          path='portfolio/*'
          element={
            <Suspense fallback={<LoadingScreen compact />}>
              <PortfolioAccountsPage />
            </Suspense>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
